import { render, staticRenderFns } from "./VerticalLayout.vue?vue&type=template&id=64d2e16c"
import script from "./VerticalLayout.vue?vue&type=script&lang=js"
export * from "./VerticalLayout.vue?vue&type=script&lang=js"
import style0 from "./VerticalLayout.vue?vue&type=style&index=0&id=64d2e16c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports